<template>
  <div class="LeftMenu">
    <div
      v-if="isMobile && showMenu"
      class="backdrop"
      aria-hidden="true"
      @click="closeMenu"
    ></div>

    <aside
      v-if="showMenu"
      ref="menuEl"
      class="menu"
      aria-label="Главное меню"
    >
      <div class="logo">
        <img src="@/assets/logo-1.svg" alt="Fox Studio" />
        <button
          class="collapse"
          type="button"
          aria-label="Свернуть меню"
          aria-expanded="true"
          @click="toggleMenu"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
      </div>

      <div class="user">
        <img
          v-if="avatar"
          class="avatar"
          :src="baseUrl + 'storage/images/' + avatar"
          alt=""
        />
        <img v-else class="avatar avatar--empty" src="@/assets/user.svg" alt="" />
        <div class="user-name">
          <span class="user-name-main">{{ displayName }}</span>
          <span class="user-name-role">Администратор</span>
        </div>
      </div>

      <nav class="links">
        <router-link
          v-for="link in links"
          :key="link.to"
          class="links-item"
          :class="{ 'is-active': isActive(link.to) }"
          :to="link.to"
          :aria-current="isActive(link.to) ? 'page' : null"
          @click="closeOnMobile"
        >
          {{ link.label }}
        </router-link>
      </nav>

      <button class="logout" type="button" @click="logout">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        <span>Выход</span>
      </button>
    </aside>

    <!-- Свёрнутая полоса: на десктопе заменяет меню, на мобильных остаётся
         на месте всегда, чтобы открытие меню не сдвигало контент -->
    <div v-if="isMobile || !showMenu" class="rail">
      <button
        ref="railButton"
        class="collapse collapse--rail"
        type="button"
        :aria-label="showMenu ? 'Свернуть меню' : 'Развернуть меню'"
        :aria-expanded="showMenu ? 'true' : 'false'"
        @click="toggleMenu"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <polyline v-if="showMenu" points="15 18 9 12 15 6" />
          <polyline v-else points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
import users from "@/composables/views/users.ts";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();

    const { baseUrl, avatar, getUser, email, name, login } = users(
      store.state.userId
    );
    return {
      avatar,
      email,
      name,
      login,
      getUser,
      baseUrl,
    };
  },
  data() {
    const isMobile = window.innerWidth <= 767;
    return {
      showMenu: !isMobile,
      isMobile,
      links: [
        { label: "Новости", to: "/news/" },
        { label: "Гороскопы", to: "/horo/" },
        { label: "Программирование", to: "/programming/" },
        { label: "Рассказы", to: "/stories/" },
        { label: "Технические задания", to: "/techtasks/" },
        { label: "Галерея", to: "/gallery/" },
        { label: "Пользователи", to: "/users/" },
        { label: "Настройки", to: "/settings/" },
      ],
    };
  },
  computed: {
    displayName() {
      return this.name || this.login || "Пользователь";
    },
  },
  watch: {
    // При переходе на другую страницу на мобильных меню закрывается
    $route() {
      if (this.isMobile) this.showMenu = false;
    },
  },
  methods: {
    isActive(to) {
      const base = to.replace(/\/+$/, "");
      const path = this.$route.path.replace(/\/+$/, "") || "/";
      return path === base || path.startsWith(base + "/");
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
      this.$nextTick(() => {
        if (!this.isMobile) return;
        const target = this.showMenu
          ? this.$refs.menuEl && this.$refs.menuEl.querySelector(".links-item")
          : this.$refs.railButton;
        if (target) target.focus();
      });
    },
    closeMenu() {
      this.showMenu = false;
      this.$nextTick(() => {
        if (this.isMobile && this.$refs.railButton) {
          this.$refs.railButton.focus();
        }
      });
    },
    closeOnMobile() {
      if (this.isMobile) this.closeMenu();
    },
    onEscape(event) {
      if (event.key === "Escape" && this.isMobile && this.showMenu) {
        this.closeMenu();
      }
    },
    onResize() {
      const isMobile = window.innerWidth <= 767;
      if (isMobile === this.isMobile) return;
      this.isMobile = isMobile;
      this.showMenu = !isMobile;
    },
    logout() {
      this.$store.commit("logout");
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    document.addEventListener("keydown", this.onEscape);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
    document.removeEventListener("keydown", this.onEscape);
  },
  async created() {
    this.getUser();
  },
};
</script>
